import React, {useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '70%',
        margin: '20px 0',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export const SelectInput = ({ onChange, value, label, options, defaultValue,name, required, ...restProps }) => {
    const classes = useStyles();
    useEffect(() => {
        if (defaultValue) {
          onChange({ target: { value: defaultValue, name: name } })
        }
    }, [])
    return (
        <div>
            <FormControl required={required} className={classes.formControl}>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                    required={required}
                    defaultValue={defaultValue}
                    name={name}
                    {...restProps}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value}
                    onChange={onChange}
                >
                    {options && Boolean(options.length) && options.map((option, index) => {
                        return (<MenuItem key={index} value={option.value}>{option.key}</MenuItem>)
                    })}
                </Select>
            </FormControl>
        </div>
    )
}